/* Super Kleen Laundry — Shopify Theme JS */

document.addEventListener('DOMContentLoaded', function() {

  // ── MOBILE MENU ──────────────────────────────────────────
  const menuBtn = document.querySelector('.mobile-menu-btn');
  const mobileNav = document.querySelector('.mobile-nav');
  if (menuBtn && mobileNav) {
    menuBtn.addEventListener('click', function() {
      const isOpen = mobileNav.style.display === 'block';
      mobileNav.style.display = isOpen ? 'none' : 'block';
      menuBtn.setAttribute('aria-expanded', !isOpen);
    });
  }

  // ── FAQ ACCORDION ────────────────────────────────────────
  document.querySelectorAll('.faq-question').forEach(function(btn) {
    btn.addEventListener('click', function() {
      const item = this.closest('.faq-item');
      const isOpen = item.classList.contains('open');
      // Close all
      document.querySelectorAll('.faq-item').forEach(function(i) { i.classList.remove('open'); });
      // Open clicked if it was closed
      if (!isOpen) item.classList.add('open');
    });
  });

  // ── STICKY HEADER SHADOW ─────────────────────────────────
  window.addEventListener('scroll', function() {
    const header = document.querySelector('.site-header');
    if (header) {
      header.style.boxShadow = window.scrollY > 20
        ? '0 4px 20px rgba(26,58,107,0.4)'
        : '0 2px 12px rgba(26,58,107,0.3)';
    }
  });

  // ── MOBILE STICKY BUTTON VISIBILITY ─────────────────────
  const stickyBtn = document.querySelector('.mobile-schedule-sticky');
  if (stickyBtn) {
    window.addEventListener('scroll', function() {
      const footer = document.querySelector('.site-footer');
      if (footer && window.innerWidth <= 767) {
        const footerTop = footer.getBoundingClientRect().top;
        stickyBtn.style.display = footerTop < window.innerHeight ? 'none' : 'block';
      }
    });
  }

  // ── CART COUNT UPDATE ────────────────────────────────────
  function updateCartCount() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(function(cart) {
        document.querySelectorAll('.cart-count').forEach(function(el) {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? 'inline-flex' : 'none';
        });
      })
      .catch(function() {});
  }
  updateCartCount();

  // ── ADD TO CART ──────────────────────────────────────────
  document.querySelectorAll('.add-to-cart').forEach(function(btn) {
    btn.addEventListener('click', function() {
      const variantId = this.dataset.variantId;
      if (!variantId) return;
      const originalText = this.textContent;
      this.textContent = 'Adding...';
      this.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
      .then(r => r.json())
      .then(function() {
        updateCartCount();
        btn.textContent = '✓ Added!';
        setTimeout(function() {
          btn.textContent = originalText;
          btn.disabled = false;
        }, 2000);
      })
      .catch(function() {
        btn.textContent = originalText;
        btn.disabled = false;
      });
    });
  });

});
